// NOTE:  This file is in the common folder but is no longer used by the client platform.
//        It is still used by the advisor platform and will remain in the common folder until that
//        is no longer the case.
const {APP_ENV, BASE_FOLDER} = window.rwOptions;

export default {
  createManifest(riaSettings) {
    // TODO: remove once ready for prod
    if (!['local', 'dev', 'qa'].includes(APP_ENV)) {
      return;
    }

    const imagePath = `${process.env.VUE_APP_BUCKET_URL}${riaSettings.squareLogo}`;
    const portalPath = `${window.location.origin}/${BASE_FOLDER}`;
    // eslint-disable-next-line camelcase
    const {headerColor} = riaSettings;

    const manifestJson = {
      short_name: 'Dashboard',
      name: 'Dashboard',
      icons: [
        {
          src: imagePath,
          type: 'image/png',
          sizes: '192x192',
        },
        {
          src: imagePath,
          type: 'image/png',
          sizes: '512x512',
        },
      ],
      start_url: portalPath,
      background_color: headerColor,
      display: 'standalone',
      scope: portalPath,
      theme_color: headerColor,
      prefer_related_applications: false,
    };
    const manifestString = JSON.stringify(manifestJson);
    const blob = new Blob([manifestString], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(blob);

    document.querySelector('#manifestJson').setAttribute('href', manifestURL);

    // non-standard apple specific tag
    document.head.innerHTML = `${document.head.innerHTML}<link rel="apple-touch-icon" href="${imagePath}">`;
  },
};
